<div class="forgot-password-wrapper">
  <i2g-form-master *ngIf="form" [form]="form">
    <i2g-input-field
      class="form-row"
      e2eId="email-address"
      fieldId="emailAddress"
      layoutDirection="column"
      [fieldControl]="emailAddress"
      [label]="'FORM.EMAIL_ADDRESS.LABEL' | translate"
    >
    </i2g-input-field>

    <button
      class="forgot-action"
      e2eId="forgot-action"
      i2gButton
      buttonStyle="emphasis"
      i2gTrackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
      (click)="submit()"
    >
      {{ 'ACTION.FORGOT_PASSWORD' | translate }}
    </button>
  </i2g-form-master>
</div>
